import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import history from '../../../lib/history'
import routes from '../../../config/routes'
import FeedbackLayout from '../../commons/Layouts/FeedbackLayout'
import ExternalLayout from '../../commons/Layouts/ExternalLayout'
import BoyWritter from '../../commons/Ilustrations/BoyWritter'
import * as reducks from '../../../reducks'

export const TITLE =
  'Você recusou os termos e condições e a política de privacidade'

export const SUBTITLE =
  'Ao recusar os termos e condições e a política de privacidade do banco Santander não será possível o acesso ao Portal Parceiros.'

export const PRIMARY_LABEL = 'Voltar'

export const SECONDARY_LABEL = 'Sair'

const TermsRefuseFeedbackContainer = () => {
  const dispatch = useDispatch()

  const handleGoBack = useCallback(() => {
    history.push(routes.terms.path)
  }, [])

  const handleLoginRedirect = useCallback(() => {
    dispatch(reducks.resources.session.actions.logout())
  }, [dispatch])

  return (
    <ExternalLayout>
      <FeedbackLayout
        title={TITLE}
        subTitle={SUBTITLE}
        primaryAction={handleGoBack}
        primaryLabelAction={PRIMARY_LABEL}
        secondaryAction={handleLoginRedirect}
        secondaryLabelAction={SECONDARY_LABEL}
        Ilustration={BoyWritter}
      />
    </ExternalLayout>
  )
}

export default TermsRefuseFeedbackContainer
